/*                                                   */
import type { Component } from "svelte";

export type ComponentOrModule<C extends Component<any, any, any> = Component<any, any, any>> =
  | C
  | { default: C };

export const getComponent = (
  componentOrModule: ComponentOrModule<Component<any, any, any>>,
): Component<any, any, any> => {
  return "default" in componentOrModule ? componentOrModule.default : componentOrModule;
};

export const resolveComponent = <C extends Component<any, any, any>>(
  component: () => ComponentOrModule<C> | Promise<ComponentOrModule<C>>,
): Promise<Component> | Component => {
  const componentOrPromise = component();

  if (Promise.resolve(componentOrPromise) === componentOrPromise) {
    return componentOrPromise.then(getComponent);
  } else {
    return getComponent(componentOrPromise as ComponentOrModule<C>);
  }
};
